
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/api/references",
      function () {
        return require("private-next-pages/developers/api/references.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/api/references"])
      });
    }
  